import { render, staticRenderFns } from "./ResetMpin.vue?vue&type=template&id=563ef4d4&scoped=true&"
import script from "./ResetMpin.vue?vue&type=script&lang=js&"
export * from "./ResetMpin.vue?vue&type=script&lang=js&"
import style0 from "./ResetMpin.vue?vue&type=style&index=0&id=563ef4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ef4d4",
  null
  
)

export default component.exports